import { CloseIcon } from "components/SVG/CloseIcon";
import { OverlayDrawer } from "packages/ui-shared/components/OverlayDrawer/OverlayDrawer";
import type { SyntheticEvent } from "react";
import React, { useEffect } from "react";
import { useSegment } from "tracking/hooks/useSegment";
import { dialog } from "components/Shop/PDPPage/PDPHeader/CoreProductInfo/ComparisonDrawer/Drawer.css";
import {
  modalContent,
  modalHeading,
  promptCloseIcon,
  promptWrapper
} from "./TraditionalRetailBanner.css";
import { TypicalRetailDescription } from "./TraditionalRetailBanner.constants";

export const TraditionalRetailModal: React.FC<{ onDismiss; isOpen? }> = ({
  onDismiss,
  isOpen
}) => {
  const { track } = useSegment();

  const handleDismiss = () => {
    track({
      event: "Page Element Clicked",
      properties: {
        module_content: "avg_typical_retail_price_pop_up",
        module_content_details: "close",
        location_type: "avg_typical_retail_price_pop_up"
      }
    });
    onDismiss();
  };

  const onCloseClick = (evt: SyntheticEvent) => {
    evt.stopPropagation();
    handleDismiss();
  };
  useEffect(() => {
    track({
      event: "Page Element Viewed",
      properties: {
        module_content: "avg_typical_retail_price_pop_up",
        location_type: "avg_typical_retail_price_pop_up"
      }
    });
  }, [track]);

  return (
    <OverlayDrawer
      isOpen={isOpen}
      anchorPosition="bottom"
      className={dialog}
      handleDismiss={handleDismiss}
    >
      <div data-testid="avg_retail_price_popup" className={promptWrapper}>
        <CloseIcon
          aria-label="Close popup"
          onClick={onCloseClick}
          className={promptCloseIcon}
        />
        <h3 className={modalHeading}>Traditional Retail Price</h3>
        <p className={modalContent}>{TypicalRetailDescription}</p>
      </div>
    </OverlayDrawer>
  );
};
